// export const baseUrl = "http://localhost:3000/api";
// export const imageUrl = "http://localhost:3000/";

// export const baseUrl = "https://findmydoctor.pk/api/api";
// export const imageUrl = "https://findmydoctor.pk/api/";

export const baseUrl = "https://craftiveagency.com/api";
export const imageUrl = "https://craftiveagency.com/";

// export const callBackUrl = `http://localhost:3001/`
// export const callBackUrl = `https://findmydoctor.pk/`;
export const callBackUrl = `https://fmd-website-rose.vercel.app/`;

export const passwordRegex =
  /^(?=.*[!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?]).{8,}$/;
